import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface ReconciliationConfirmDialogData {
  title: string;
  /** Um parágrafo por item. */
  lines: string[];
  confirmLabel: string;
  cancelLabel?: string;
  icon?: string;
  tone?: 'primary' | 'warning' | 'danger';
}

/** Confirmação simples (lote, importação com conta diferente): fecha com `true` ao confirmar. */
@Component({
  selector: 'app-reconciliation-confirm-dialog',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReconciliationConfirmDialogComponent {
  protected readonly data = inject<ReconciliationConfirmDialogData>(MAT_DIALOG_DATA);
  private readonly _dialogRef = inject(MatDialogRef<ReconciliationConfirmDialogComponent, boolean>);

  protected confirm(): void {
    this._dialogRef.close(true);
  }

  protected cancel(): void {
    this._dialogRef.close(false);
  }
}
